import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useForm } from 'react-hook-form';
import { ListGroup, ListGroupItem, Button, Collapse, Media, Card, CardHeader, CardBody, FormGroup, Input, Form, Label } from 'reactstrap'

import { useEditorState, useEditorActions } from '../../editor-context'
import { getMongoObjectId, truncate } from 'utils'
import { fetcher } from 'api/client';
import useFileUpload from 'api/hooks/file/useFileUpload';
import { contractAction } from 'api/actions/contracts';
import bootbox from 'components/Modals/Bootbox';

export function AttachmentList() {
    const { t } = useTranslation();
    const { document: doc, isContentLocked, isEditable } = useEditorState();

    return (
        <ListGroup>
            {
                doc?.participants?.map((participant, index) => (
                    <ParticipantItem 
                        key={participant._id}
                        contractId={doc._id}
                        participant={participant}
                        index={index + 1}
                        isContentLocked={isContentLocked}
                        isContractEditable={isEditable}
                    />
                ))
            }
            {
                !doc?.participants?.length &&
                t('editor.attachments.empty_participants')
            }
        </ListGroup>
    )
}

function ParticipantItem({ contractId, participant, index, isContentLocked, isContractEditable }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState();
    const { addParticipantAttachment, removeParticipantAttachment } = useEditorActions();
    const { mutate: mutateAddAttachment } = useMutation((payload) => fetcher(contractAction(contractId, 'addattachment', payload)), {
        onSuccess: (data, variables) => {
            // queryClient.setQueryData(contractQueryId, data.contract)
        },
    })
    // const { chooseFileAndUploadFile  } = useFileUpload({
    //     onSuccess: async ( { url, name, fileId }, variables) => {
    //         await mutateAddAttachment({
    //             filename: name,
    //             participantId: participant._id,
    //             subject: variables.name,
    //             required: variables.required,
    //             url,
    //             fileId,
    //         })
    //     },
    // })

    const toggle = () => setIsOpen(open => !open)

    const handleAddAttachment = () => {
        const newAttachment = { 
            subject: t('editor.attachments.new_name'), 
            required: true, 
            participantId: participant._id,
            _id: getMongoObjectId() 
        }
        addParticipantAttachment(newAttachment)
    }

    const handleRemoveAttachment = (attachment) => {
        removeParticipantAttachment({
            participantId: participant._id,
            attachmentId: attachment._id
        })
    }

   

    return (
        <ListGroupItem className="m-0 p-0 bg-light text-dark">
            <Media className="text-dark d-flex align-items-center border-bottom">
                <Media className={`p-2 participant${index}`}>
                    <img src={`/images/editor/icons/participants/${participant.obligation}.svg`} alt={participant.obligation} height="40px" />
                </Media>
                <Media body className="participant-title px-2">
                    <Media >{truncate(participant.label, 25)}</Media>
                    <Media >{participant.attachments.length} {participant.attachments.length === 1 ? t('editor.attachments.number_single') : t('editor.attachments.number_multiple')}</Media>
                </Media>
                <Media className="px-2" onClick={toggle}>
                        <i className={`fas pointer fa-chevron-${isOpen ? 'down' : 'up'}`} />
                </Media>
            </Media>
            <Collapse isOpen={isOpen}>
                <Media  body>
                    {
                        participant?.attachments?.map(attachment => (
                            <AttachmentItem
                                key={attachment._id}
                                participantId={participant._id}
                                agendaDocuments={participant?.agendaProperties?.documents}
                                attachment={attachment} 
                                onRemove={handleRemoveAttachment}
                                isContentLocked={isContentLocked}
                                isContractEditable={isContractEditable}
                                
                            />
                        ))
                    }
                    {
                        !participant?.attachments?.length && t('editor.attachments.empty')
                    }
                </Media>
                {!isContentLocked && isContractEditable &&
                    <div className="text-center m-1" onClick={handleAddAttachment}>
                        <Button color="light" data-action="add-attachment">
                            <i className="fas fa-plus"></i> {t('editor.attachments.add')}
                        </Button>
                    </div>
                }
            </Collapse>
        </ListGroupItem>
    )
}

function AttachmentItem({ attachment, isContentLocked, participantId, agendaDocuments = [], isContractEditable,  onRemove, onUpload }) {
    const { t } = useTranslation();
    const [localAttachment, setAttachment] = useState(attachment);
    const [isEditable, setIsEditable] = useState(attachment.createdAt === attachment.updatedAt);
    const { register , handleSubmit } = useForm();

    const onFileUploadSuccess = async ( { url, name, fileId }, variables) => {
        const updatedAttachment = {
            ...localAttachment,
            url,
            filename: name
        }
        setAttachment(updatedAttachment)
        updateParticipantAttachment({
            participantId,
            attachment: updatedAttachment
        })
        setIsEditable(false)
    }

    const { chooseFileAndUploadFile  } = useFileUpload({
        onSuccess: onFileUploadSuccess,
    })
    const { updateParticipantAttachment } = useEditorActions();

    const toggleEdit = () => { setIsEditable(open => !open) }

    const handleSave = (data) => {
        toggleEdit()
        updateParticipantAttachment({
            participantId,
            attachment: {
                ...localAttachment,
                ...data
            }
        })
    }

    const handleRemove = () => {
        onRemove(attachment)
    }

    const handleUpload = () => {
        const hasAgendaDocuments = !!agendaDocuments?.length;

        console.log({agendaDocuments})

        if (hasAgendaDocuments) {
            return bootbox.dialog({
                title: 'Cargar documento desde',
                message: 'Elige el archivo a cargar',
                closeButton: true,
                buttons: {
                    // cancel: {
                    //     label: t('contracts.options.cancel'),
                    //     className: 'none btn-ligth',
                    //     callback: () => {
                            
                    //     },
                    // },
                    file: {
                        label: t('Mi equipo'),
                        className: 'btn-secondary',
                        color: 'secondary',
                        callback: async () => {
                            chooseFileAndUploadFile({ convertToPdf: true }, {
                                accept: '.pdf,image/*'
                            })
                        },
                    },
                    main: {
                        label: t('Agenda'),
                        color: 'primary',
                        callback: async () => {
                            const fileToUpload = await bootbox.prompt({
                                title: t('Selecciona el archivo'),
                                message: t('Selecciona el archivo'),
                                buttons: {
                                  cancel: { label: 'Cancelar', },
                                  confirm: { label: 'Aceptar', },
                                },
                                inputType: 'select',
                                inputOptions: agendaDocuments.map(doc => (
                                    { value: `${doc.name}|||${doc.url}`, label: doc.name }
                                )), 
                               
                              })
                              if (fileToUpload) {
                                const [docName, url] = fileToUpload.split('|||');
                                onFileUploadSuccess({ url, name: docName  })
                              }
                              
                        },

                    },
                },
            });
        }

        chooseFileAndUploadFile({ convertToPdf: true }, {
            accept: '.pdf,image/*'
        })
    }

    const handleClearAttachment = () => {
        // attachment.set('attachmentValidate', undefined, { silent: true });
        // attachment.set('rejectMessage', '', { silent: true });
        // attachment.set('validated', false);
        // attachment.unset('url');
        // attachment.set('locked', false);
        setAttachment(oldAttachment => ({
            ...oldAttachment,
            url: null,
            filename: null,
            attachmentValidate: null,
            rejectMessage: '',
            validated: false,
            locked: false,
        }))
    }

    useEffect(() => {
        setAttachment(attachment)
    }, [attachment])

    return (
        <Card className="bg-light">
            <CardHeader>
            {!isContentLocked && isContractEditable &&
                <div className="float-right">
                    {!localAttachment.url && isEditable && 
                        <>
                            <Button color="light-contrast" data-action="upload-attachment" size="sm" className="ml-2" onClick={handleUpload}>
                                <i className="fas fa-upload text-success" title={t('editor.attachments.upload')}></i>
                            </Button>
                            <input type="file" className="d-none file-input" accept=".pdf,image/*"/>
                        </>
                    }
                     <Button color="light-contrast" data-action="edit" size="sm" className="ml-2" onClick={toggleEdit}>
                        <i className="fas fa-pen" title={t('editor.attachments.edit')}></i>
                    </Button>
                     <Button color="light-contrast" data-action="delete" size="sm" className="ml-2" onClick={handleRemove}>
                        <i className="fas fa-times text-danger" title={t('editor.attachments.delete')}></i>
                    </Button>
                </div>
            }
            <div className="attachment-item-content" onClick={!isContractEditable ? toggleEdit : undefined}>
                <span className="attachment-name">
                    - {localAttachment.name} {localAttachment.required && '*'} 
                    {localAttachment.url && t('editor.attachments.uploaded')}
                </span>
            </div>
            </CardHeader>
            <Collapse isOpen={isEditable}>
                <CardBody className="bg-light">
                    { !!localAttachment.url &&
                        <div className="border-bottom p-1">
                            <strong>{t('editor.attachments.uploaded')}:</strong> <u><a href={localAttachment.url} className="text-underline text-dark" target="_blank" rel="noreferrer">{localAttachment.name}</a></u>
                            {
                                isContractEditable &&
                                <a href="#" data-action="clear-attachment" className="pull-right ml-2" onClick={handleClearAttachment}>
                                    <i className="fas fa-times text-danger" title={t('editor.attachments.delete_uploaded')}></i>
                                </a>
                            }

                        </div>
                    }
                    <Form className="p-2">
                        <FormGroup>
                            <Label>{t('editor.attachments.name')}:</Label>
                            <Input 
                                type="text" 
                                className="form-control input-sm" 
                                placeholder={t('editor.attachments.name_placeholder')} 
                                name="name" 
                                innerRef={register}
                                defaultValue={localAttachment.name}
                                disabled={!isContractEditable}
                            />
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                            <Input 
                                type="checkbox" 
                                name="required" 
                                innerRef={register}
                                defaultChecked={localAttachment.required}
                                disabled={!isContractEditable}
                             />{' '}
                            {t('editor.attachments.required')}
                            </Label>
                        </FormGroup>
                    </Form>
                    <div className="text-right">
                        <Button hidden={!isContractEditable} color="light" className="bg-light-light" size="sm" data-action="save-edit" onClick={handleSubmit(handleSave)}>
                            <i className="fas fa-check"></i> {t('editor.attachments.save')}
                        </Button>
                    </div>
                </CardBody>
                </Collapse>
            
        </Card>
    )
}